<template>
  <div v-if="!!phaseData">
    <div>Selecione os questionários que deseja preencher ou enviar para o paciente</div>
    <div class="d-flex flex-wrap survey-option-box">
      <div class="survey-option" v-for="survey in surveys" :key="survey.key">
        <v-checkbox
          v-model="surveysToSend[survey.key]"
          class="checkbox"
          :class="surveysToSend[survey.key] || phaseData.sentSurveys[survey.key] ? 'selected-checkbox' : ''"
          dense
          hide-details
          :disabled="phaseData.sentSurveys[survey.key] ? true : false"
        >
          <template v-slot:label>
            <div class="pr-3 py-5">{{ survey.label }}</div>
            <info-btn color="success" size="medium" v-if="survey.modal" @click.stop @click="showModal(survey)" />
          </template>
        </v-checkbox>
      </div>
    </div>
    <v-dialog max-width="60vw" v-model="modalVisible">
      <v-card>
        <v-card-title
          ><p class="mr-auto">{{ selectedSurvey.label }}</p>
          <v-btn icon color="primary" @click="hideModal"><v-icon>mdi-close-circle-outline</v-icon></v-btn></v-card-title
        >
        <v-card-text>
          <div v-if="selectedSurvey.key === 'uas7'">
            <v-img :src="publicStorageUrl + '/uce-complementar/uas7-1.png'" />
            <v-img :src="publicStorageUrl + '/uce-complementar/uas7-2.png'" />
          </div>
          <div v-if="selectedSurvey.key === 'uct'">
            <v-img width="100%" :src="publicStorageUrl + '/uce-complementar/UTC.png'" />
          </div>
          <p v-if="selectedSurvey.key === 'cuq2ol'">
            A versão validada em português brasileiro é aplicada utilizando escala de pontuação de 1 a 5, sendo: 1 -
            Nada; 2 - Pouco; 3 - Mais ou menos; 4 - Muito; 5 - Muitíssimo. O score total varia de 23 a 115. Não existe
            ainda um cut-off para definir prejuízo significante da qualidade de vida em pacientes com urticária crônica,
            mas o questionário CU-Q2oL pode ser útil para: avaliar a evolução e/ou resposta ao tratamento em um mesmo
            paciente ao longo do tempo. <br />
            O objetivo deste questionário é medir o quanto a URTICÁRIA afetou a sua vida no decorrer dos últimos 15
            dias, Cada pergunta tem 5 opções de respostas: NADA, POUCO, MAS OU MENOS, MUITO ou MUITÍSSIMO. Marque com um
            "Xº uma resposta para cada pergunta. Pedimos a gentileza de verificar se todas as perguntas foram
            respondidas. Muito obrigado!
          </p>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row
      class="mb-12 mt-4"
      :class="{
        'justify-center': $vuetify.breakpoint.width < 600,
      }"
    >
      <v-col class="ml-2"> *Obrigatório para o plano de saúde </v-col>
      <v-col class="d-flex flex-column justify-end mr-2 flex-grow-1 items-center align-center" cols="5">
        <v-btn class="btn-min-width" color="primary" @click="sendSelectedSurveys" :disabled="sending" block>
          <v-progress-circular indeterminate color="primary" v-if="sending" width="2" size="20"></v-progress-circular>
          <template v-else> <v-icon size="16px" class="mr-2">mdi-send</v-icon>Enviar para o paciente </template></v-btn
        >
        <v-btn
          v-if="showSendAgain"
          color="primary"
          text
          x-small
          @click="sendSurveyLink(true)"
          class="mt-2"
          :disabled="isResendButtonDisabled || resending"
        >
          <v-progress-circular indeterminate color="primary" v-if="resending" width="2" size="12"></v-progress-circular>
          <template v-else> reenviar links para o paciente </template>
        </v-btn>
      </v-col>
    </v-row>
    <v-expansion-panels class="mb-4" multiple>
      <v-expansion-panel>
        <v-expansion-panel-header>PREENCHER À PARTIR DE HISTÓRICO</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-data-table
            disable-pagination
            :items="surveyHistory"
            no-results-text="Nenhum questionário respondido"
            loading-text="Carregando dados..."
            :headers="headers"
            :footer-props="footerOptions"
          >
            <template #[`item.actions`]="{ item }">
              <v-btn color="primary" class="white--text" @click="fillForm(item)">preencher {{ item.type }}</v-btn>
            </template>
            <template #[`item.updatedAt`]="{ item }">
              {{ $moment(item).format('DD/MM/YYYY') }}
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="getSurveyHistory"> Recarregar </v-btn>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>UAS7</v-expansion-panel-header>
        <v-expansion-panel-content class="pb-4">
          <v-switch class="my-4" label="Aplicar resultado manualmente" v-model="phaseData.uas7.manual" hide-details />
          <v-row>
            <div class="col-sm-3 col-md-12 col-lg-3 col">
              <v-menu
                ref="pickUas7Date"
                v-model="pickUas7Date"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="phaseData.uas7.date ? $moment(phaseData.uas7.date).format('DD/MM/YYYY') : 'Data'"
                    solo
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="phaseData.uas7.date"
                  no-title
                  @change="pickUas7Date = false"
                  locale="pt-br"
                  :max="$moment().subtract(1, 'days').toISOString()"
                ></v-date-picker>
              </v-menu>
            </div>
          </v-row>
          <div class="mt-4 d-flex flex-row gap-12">
            <field-label label="UAS7">
              <div class="d-flex gap-2 mt-2 align-center">
                <text-field
                  :min="0"
                  type="number"
                  v-if="phaseData.uas7.manual"
                  v-model="phaseData.uas7.value"
                  :max="30"
                />
                <span v-else class="big-number">{{
                  phaseData.uas7.value == null ? 'Indefinido' : phaseData.uas7.value
                }}</span>
              </div>
            </field-label>
          </div>
          <v-simple-table class="footer-table mt-4">
            <template v-slot:default>
              <thead class="footer-table-head">
                <tr>
                  <th class="text-left">VALOR</th>
                  <th class="text-left">URTICÁRIAS</th>
                  <th class="text-left">PRURIDO (COCEIRA)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in tableItems" :key="item.name">
                  <td>{{ item.valor }}</td>
                  <td>{{ item.urticaria }}</td>
                  <td>{{ item.prurido }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-simple-table class="footer-table mt-4">
            <template v-slot:default>
              <thead class="footer-table-head">
                <tr>
                  <th class="text-left">DIA</th>
                  <th class="text-center">01</th>
                  <th class="text-center">02</th>
                  <th class="text-center">03</th>
                  <th class="text-center">04</th>
                  <th class="text-center">05</th>
                  <th class="text-center">06</th>
                  <th class="text-center">07</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>COCEIRA</td>
                  <td v-for="day in 7" :key="day + '_urticariaDays'" class="table-textfield">
                    <v-text-field outlined v-model="phaseData.uas7.prurido['dia' + day]" hide-details />
                  </td>
                </tr>
                <tr>
                  <td>URTICARIA</td>
                  <td v-for="day in 7" :key="day + '_urticariaDays'" class="table-textfield">
                    <v-text-field outlined v-model="phaseData.uas7.urticaria['dia' + day]" hide-details />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>UCT</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-switch class="my-4" label="Aplicar resultado manualmente" v-model="phaseData.uct.manual" hide-details />
          <v-row>
            <div class="col-sm-3 col-md-12 col-lg-3 col">
              <v-menu
                ref="pickUctStartDate"
                v-model="pickUctStartDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="
                      phaseData.uct.startDate ? $moment(phaseData.uct.startDate).format('DD/MM/YYYY') : 'Data Inicial'
                    "
                    solo
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="phaseData.uct.startDate"
                  no-title
                  @change="pickUctStartDate = false"
                  locale="pt-br"
                  :max="$moment().subtract(1, 'days').toISOString()"
                ></v-date-picker>
              </v-menu>
            </div>
          </v-row>
          <div class="mt-4 d-flex flex-row gap-12">
            <field-label label="UCT">
              <div class="d-flex gap-2 mt-2 align-center">
                <text-field
                  :min="0"
                  type="number"
                  v-if="phaseData.uct.manual"
                  v-model="phaseData.uct.value"
                  :max="30"
                />
                <span v-else class="big-number">{{
                  phaseData.uct.value == null ? 'Indefinido' : phaseData.uct.value
                }}</span>
              </div>
            </field-label>
          </div>
          <div class="mt-6">
            <p class="uct-info">
              Instruções: Você sofre de urticária. Com as seguintes perguntas nós gostaríamos de avaliar o estado atual
              da sua doença. Por favor, leia atentamente cada pergunta e escolha, entre as cinco respostas existentes,
              aquela que mais se aproxima do seu caso. Por favor, não demore a pensar na resposta e lembre-se de
              responder a todas as perguntas e escolher apenas uma resposta para cada pergunta.
            </p>
          </div>
          <div class="mt-6" v-if="!phaseData.uct.manual">
            <radio-options
              class="mb-2"
              v-for="question in uctQuestions"
              :key="question.key"
              :label="question.name"
              v-model="phaseData.uct.profile[question.key].value"
              row
              clearable
              :options="uctOptions"
            />
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>DLQI</v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="mb-2 cuq2ol-header">ÍNDICE DE QUALIDADE DE VIDA EM DERMATOLOGIA</div>
          <v-switch class="my-4" label="Aplicar resultado manualmente" v-model="phaseData.dlqi.manual" hide-details />
          <v-row>
            <div class="col-sm-3 col-md-12 col-lg-3 col">
              <v-menu
                ref="pickDlqiDate"
                v-model="pickDlqiDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="phaseData.dlqi.date ? $moment(phaseData.dlqi.date).format('DD/MM/YYYY') : 'Data'"
                    solo
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="phaseData.dlqi.date"
                  no-title
                  @change="pickDlqiDate = false"
                  locale="pt-br"
                  :max="$moment().subtract(1, 'days').toISOString()"
                ></v-date-picker>
              </v-menu>
            </div>
          </v-row>
          <div class="mt-4 d-flex flex-row gap-12">
            <field-label label="DLQI">
              <div class="d-flex gap-2 mt-2 align-center">
                <text-field
                  :min="0"
                  type="number"
                  v-if="phaseData.dlqi.manual"
                  v-model="phaseData.dlqi.value"
                  :max="30"
                />
                <span
                  v-else
                  :class="{
                    'red--text': phaseData.dlqi.value > 9,
                    'black--text text-h6': phaseData.dlqi.value == null,
                    'big-number': phaseData.dlqi.value != null,
                  }"
                  >{{ phaseData.dlqi.value == null ? 'Indefinido' : phaseData.dlqi.value }}</span
                >
                <span
                  v-if="phaseData.dlqi.value"
                  class="ml-2"
                  :class="{ 'red--text': phaseData.dlqi.value > 9 }"
                  style="width: 120px"
                  >{{ phaseData.dlqi.value > 9 ? 'Moderado a grave' : 'Leve' }}</span
                >
              </div>
            </field-label>
          </div>

          <div class="mt-12" v-if="!phaseData.dlqi.manual">
            <radio-options
              class="mb-2"
              v-for="dlqiOption in dlqiOptions"
              :key="dlqiOption.key"
              v-show="
                dlqiOption.key !== 'impedimento_trabalho_estudo_passado' ||
                phaseData.dlqi.profile['impedimento_trabalho_estudo_atual'].value === 0
              "
              :label="dlqiOption.name"
              v-model="phaseData.dlqi.profile[dlqiOption.key].value"
              row
              clearable
              :options="dlqiOption.options || defaultDlqiOptions"
              @input="checkDlqi(dlqiOption.key, $event)"
            />
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>CU-Q2oL</v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="mb-2 cuq2ol-header">ÍNDICE DE QUALIDADE DE VIDA NA URTICÁRIA CRÔNICA</div>
          <div class="mt-4 d-flex flex-row gap-12">
            <field-label label="CU-Q2oL">
              <div class="d-flex gap-2 mt-2 align-center">
                <span class="big-number">{{ computedCuq2ol }}</span>
              </div>
            </field-label>
          </div>
          <field-label v-for="topic in cuq2olOptions" :key="topic.key" :label="topic.label" class="mt-2">
            <radio-options
              v-for="question in topic.questions"
              :label="question.label"
              :key="question.key"
              :clearable="true"
              :options="defaultOptions"
              v-model="phaseData.cuq2ol[question.key]"
              row
              class="ml-2"
            />
          </field-label>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <field-label class="mt-8" label="Anotações">
      <text-area :readonly="disabled" :max-length="2000" v-model="phaseData.notes" />
    </field-label>
  </div>
</template>
<script>
import { CUQ2OL_OPTIONS } from '@/components/AttendanceForm/csu/constants/cuq2ol.js'
import { UCT_OPTIONS, UCT_QUESTIONS } from '@/components/AttendanceForm/csu/constants/uct'
import { DLQI_OPTIONS } from '@/components/AttendanceForm/general/constants/dlqiOptions'
import BasePhase from '@/components/AttendanceForm/general/phase/BasePhase.vue'
import FieldLabel from '@/components/FieldLabel.vue'
import RadioOptions from '@/components/RadioOptions.vue'
import TextArea from '@/components/TextArea.vue'
import TextField from '@/components/TextField.vue'
import { createNamespacedHelpers } from 'vuex'
import InfoBtn from '@/components/InfoBtn.vue'
import { PUBLIC_STORAGE_URL } from '@/constants/global'

const { mapGetters: attendanceGettersMap } = createNamespacedHelpers('attendance')
const { mapGetters: authGettersMap } = createNamespacedHelpers('auth')

export default {
  extends: BasePhase,
  components: { FieldLabel, RadioOptions, TextField, TextArea, InfoBtn },
  data() {
    return {
      pickUctStartDate: false,
      pickDlqiDate: false,
      pickUas7Date: false,
      footerOptions: {
        'page-text': '{0}-{1} de {2}',
        'items-per-page-text': 'Itens por página',
        'items-per-page-all-text': 'Todos',
        'items-per-page-options': [5, 10, 25, 50],
      },
      headers: [
        { text: 'Tipo', value: 'type' },
        { text: 'Respondido em', value: 'updatedAt' },
        { text: '', value: 'actions', align: 'end' },
      ],
      surveyHistory: [],
      surveysToSend: {
        uas7: false,
        dlqi: false,
        uct: false,
        cuq2ol: false,
      },
      surveys: [
        {
          key: 'uas7',
          label: 'UAS7*',
          modal: true,
        },
        {
          key: 'uct',
          label: 'UCT',
          modal: true,
        },
        {
          key: 'dlqi',
          label: 'DLQI',
        },
        {
          key: 'cuq2ol',
          label: 'CU-Q2oL',
          modal: true,
        },
      ],
      tableItems: [
        {
          valor: 0,
          urticaria: 'Nenhum',
          prurido: 'Nenhum',
        },
        {
          valor: 1,
          urticaria: 'Leve (Menos de 20 em 24 h)',
          prurido: 'Leve (presente mas não incomoda)',
        },
        {
          valor: 2,
          urticaria: 'Moderado  (20 a 50 em 24h)',
          prurido: 'Moderado (incômodo mas não interfere nas atividades diárias ou no sono)',
        },
        {
          valor: 3,
          urticaria: 'Intenso  (mais de 50 ou grandes áreas em 24h)',
          prurido: 'Intenso (prurido severo que atrapalha o sono e atividades diárias',
        },
      ],
      uctQuestions: UCT_QUESTIONS,
      uctOptions: UCT_OPTIONS,
      cuq2olOptions: CUQ2OL_OPTIONS,
      defaultOptions: [
        {
          text: 'Nada',
          value: 1,
        },
        {
          text: 'Pouco',
          value: 2,
        },
        {
          text: 'Mais ou Menos',
          value: 3,
        },
        {
          text: 'Muito',
          value: 4,
        },
        {
          text: 'Muitíssimo',
          value: 5,
        },
      ],
      showSendAgain: false,
      isResendButtonDisabled: false,
      sending: false,
      resending: false,
      phaseData: {
        dlqi: {
          manual: false,
          value: null,
          date: {},
          profile: [],
        },
        uct: {
          manual: false,
          value: null,
          startDate: null,
          profile: {},
        },
        uas7: {
          manual: false,
          value: null,
          date: null,
          urticaria: {},
          prurido: {},
        },
        cuq2ol: {},
      },
      selectedSurvey: {},
      modalVisible: false,
      publicStorageUrl: PUBLIC_STORAGE_URL,
    }
  },
  computed: {
    ...attendanceGettersMap(['attendance']),
    ...authGettersMap(['personId']),
    ...attendanceGettersMap(['attendancePatient']),
    defaultDlqiOptions() {
      return [
        { text: 'Realmente muito', value: 3 },
        { text: 'Bastante', value: 2 },
        { text: 'Um pouco', value: 1 },
        { text: 'Nada', value: 0 },
      ]
    },
    computedDlqi() {
      if (!this.phaseData || this.phaseData.dlqi.manual) {
        return this.phaseData?.dlqi?.value || 0
      }

      let result = 0
      for (let option of this.dlqiOptions) {
        let value = this.phaseData.dlqi.profile[option.key]?.value || 0
        if (!parseInt(value)) {
          continue
        }

        result += value
      }
      return result
    },
    computedUct() {
      if (!this.phaseData || this.phaseData.uct.manual) {
        return this.phaseData?.uct?.value || 0
      }
      if (Object.keys(this.phaseData.uct.profile).some((key) => this.phaseData.uct.profile[key].value === null)) {
        return null
      }

      let result = 0
      for (let option of this.uctQuestions) {
        let value = this.phaseData.uct.profile[option.key]?.value || 0
        if (!parseInt(value)) {
          continue
        }

        result += value
      }
      return result
    },
    computedUas7() {
      if (!this.phaseData || this.phaseData.uas7.manual) {
        return this.phaseData?.uas7?.value || 0
      }

      if (
        Object.keys(this.phaseData.uas7.urticaria).some((key) => this.phaseData.uas7.urticaria[key] === null) ||
        Object.keys(this.phaseData.uas7.prurido).some((key) => this.phaseData.uas7.prurido[key] === null)
      ) {
        return null
      }

      let result = 0
      let dayArray = ['1', '2', '3', '4', '5', '6', '7']
      dayArray.forEach((day) => {
        let urticariaValue = this.phaseData.uas7.urticaria['dia' + day] || 0
        let pruridoValue = this.phaseData.uas7.prurido['dia' + day] || 0
        result += parseInt(urticariaValue) + parseInt(pruridoValue)
      })
      return result
    },
    computedCuq2ol() {
      if (!this.phaseData || !this.phaseData.cuq2ol || Object.keys(this.phaseData.cuq2ol) === 0) {
        return 0
      }
      let result = 0
      for (let symptomValue of Object.keys(this.phaseData.cuq2ol)) {
        result += this.phaseData.cuq2ol[symptomValue]
      }
      return result
    },
    dlqiOptions() {
      return DLQI_OPTIONS.ADULT
    },
  },
  methods: {
    getDefaultData() {
      const data = {
        cuq2ol: {},
        sentSurveys: {},
        dlqi: {
          date: null,
          value: 0,
          manual: false,
          profile: this.buildEmptyProfile(),
        },
        uct: {
          startDate: null,
          value: 0,
          manual: false,
          profile: this.buildEmptyUctProfile(),
        },
        uas7: {
          date: null,
          value: 0,
          manual: false,
          urticaria: {
            dia1: null,
            dia2: null,
            dia3: null,
            dia4: null,
            dia5: null,
            dia6: null,
            dia7: null,
          },
          prurido: {
            dia1: null,
            dia2: null,
            dia3: null,
            dia4: null,
            dia5: null,
            dia6: null,
            dia7: null,
          },
        },
        notes: null,
      }
      return data
    },
    fillForm(form) {
      let formCopy = JSON.parse(JSON.stringify(form.data))
      let surveyDate = form.updatedAt
      delete formCopy.startedAt
      delete formCopy.done
      if (form.type === 'UCT') {
        this.phaseData.uct.startDate = surveyDate
        this.phaseData.uct.profile = formCopy
      }
      if (form.type === 'DLQI') {
        this.phaseData.dlqi.date = surveyDate
        this.phaseData.dlqi.profile = formCopy
      }
      if (form.type === 'CUQ2OL') {
        for (let key in formCopy) {
          formCopy[key] = formCopy[key].value
        }
        this.phaseData.cuq2ol = formCopy
      }
      if (form.type === 'UAS7') {
        this.phaseData.uas7.date = surveyDate
        this.phaseData.uas7.urticaria = formCopy.urticaria
        this.phaseData.uas7.prurido = formCopy.prurido
      }
    },
    async getSurveyHistory() {
      const surveysCompleted = await this.$api.getPatientSurveys(this.attendance.patient.id, this.personId)
      surveysCompleted.forEach((survey) => {
        if (survey.data.done) {
          this.surveyHistory.push(survey)
        }
      })
    },
    async sendSelectedSurveys() {
      const errors = []

      if (Object.values(this.surveysToSend).every((value) => value === false)) {
        this.$root.warn('Não há questionários para enviar.')
        if (Object.values(this.phaseData.sentSurveys).some((value) => typeof value === 'string')) {
          this.showSendAgain = true
        }
        return
      }

      for (let survey in this.surveysToSend) {
        if (this.surveysToSend[survey]) {
          try {
            this.sending = true
            let newsurvey = await this.$api.createSurveyFromAttendance(
              this.attendance.id,
              this.attendance.patient.id,
              this.personId,
              survey.toUpperCase(),
            )
            this.phaseData.sentSurveys = { ...this.phaseData.sentSurveys, [survey]: newsurvey.uuid }
            await this.sendSurveyLink(false)
          } catch {
            errors.push(survey)
          } finally {
            this.sending = false
          }
        }
      }
      if (errors.length > 0) {
        this.$root.error(`Os seguintes questionários não foram enviados: ${errors.join(', ')}`)
      } else {
        this.$root.ok('Questionários enviados com sucesso!')
        this.surveysToSend = {
          uas7: false,
          dlqi: false,
          uct: false,
          cuq2ol: false,
        }
      }
    },
    async sendSurveyLink(redo) {
      const surveysToSendLink = []
      for (let survey in this.phaseData.sentSurveys) {
        surveysToSendLink.push({
          type: survey.toUpperCase(),
          uuid: this.phaseData.sentSurveys[survey],
        })
      }
      try {
        redo ? (this.resending = true) : (this.resending = false)
        await this.$api.sendSurveyToPatient(surveysToSendLink, this.attendance.patient.id, this.personId)
        this.$root.ok('Links enviados com sucesso!')
        redo ? (this.isResendButtonDisabled = true) : (this.isResendButtonDisabled = false)
      } catch {
        this.$root.error('Não foi possível enviar os links, tente novamente mais tarde.')
      } finally {
        this.resending = false
      }
    },
    buildEmptyProfile() {
      return this.dlqiOptions.reduce((acc, option) => ({ ...acc, [option.key]: { value: null } }), {})
    },
    buildEmptyUctProfile() {
      return this.uctQuestions.reduce((acc, option) => ({ ...acc, [option.key]: { value: null } }), {})
    },
    checkDlqi(key, value) {
      if (key === 'impedimento_trabalho_estudo_atual' && this.phaseData.dlqi.profile[key].value !== 0) {
        this.phaseData.dlqi.profile['impedimento_trabalho_estudo_passado'] = { value: null }
      }
    },

    postPhaseDataLoaded() {
      if (this.phaseData.dlqi.profile['impedimento_trabalho_estudo_atual'].value === 'NAO') {
        this.phaseData.dlqi.profile['impedimento_trabalho_estudo_atual'].value = 0
      }
    },
    showModal(survey) {
      this.selectedSurvey = survey
      this.modalVisible = true
    },
    hideModal() {
      this.modalVisible = false
    },
  },
  watch: {
    computedDlqi(newVal) {
      if (this.phaseData.dlqi.manual) {
        return
      }
      this.phaseData.dlqi.value = Number(newVal)
    },
    computedUct(newVal) {
      if (this.phaseData.uct.manual) {
        return
      }
      this.phaseData.uct.value = newVal != null ? Number(newVal) : null
    },
    computedUas7(newVal) {
      if (this.phaseData.uas7.manual) {
        return
      }
      this.phaseData.uas7.value = newVal != null ? Number(newVal) : null
    },
  },
  async mounted() {
    await this.getSurveyHistory()
  },
}
</script>

<style scoped>
.survey-option-box {
  gap: 8px;
}
.survey-option {
  min-width: 144px;
}

.btn-min-width {
  min-width: 252px !important;
}

.uct-info {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.02em;
  color: #78909c;
}
.cuq2ol-header {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.02em;
  color: #1976d2;
}
.checkbox {
  display: flex;
  align-items: center;
}
.selected-checkbox {
  border: 1px solid #1976d2;
}
.big-number {
  font-weight: medium;
  color: green;
  font-size: 2.5rem;
}
.area-box {
  border: 1px solid grey;
  border-radius: 10px;
}
.slider-image {
  border: 4px solid #1976d2;
}
.footer-table-head {
  background: #a9ade040;
}
.footer-table {
  border-collapse: collapse;
}
.footer-table td,
.footer-table th {
  border: 1px solid #78909c;
}
:deep(.table-textfield)
  .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
  > .v-input__control
  > .v-input__slot
  fieldset {
  color: transparent !important;
}
</style>
